



























































import Vue from "vue";
import "vue-simple-suggest/dist/styles.css";
import CorporateSideTabs from "@/parts/corporate/CorporateSideTabs.vue";
import { NotificationSetting } from '@/api/dto/Notification';
import { getNotificationSetting, updateNotificationSetting } from '@/api/Notification';

interface NoticeInputs {
  assessment: { title: string; description: string; type: string; site: boolean; mail: boolean };
  assessmentComment: { title: string; description: string; type: string; site: boolean; mail: boolean };
  projectComment: { title: string; description: string; type: string; site: boolean; mail: boolean };
  service: { title: string; description: string; type: string; site: boolean; mail: boolean };
  system: { title: string; description: string; type: string; site: boolean; mail: boolean };
}

interface Data {
  noticeInputs: NoticeInputs;
  notificationSetting: NotificationSetting,
}

export default Vue.extend({
  name: "NoticeSettings",
  components: {
    CorporateSideTabs,
  },
  data(): Data {
    this.$store.commit("setMode", { mode: "notice" });
    return {
      noticeInputs: {
        assessment: {
          title: "作成した依頼に査定がきたとき",
          description: "",
          type: "checkbox",
          site: false,
          mail: false,
        },
        assessmentComment: {
          title: "作成した依頼にコメントがきたとき",
          description: "",
          type: "checkbox",
          site: false,
          mail: false,
        },
        projectComment: {
          title: "参加プロジェクトの依頼にコメントがきたとき",
          description: "",
          type: "checkbox",
          site: false,
          mail: false,
        },
        service: { title: "サービスに関するお知らせ", description: "", type: "checkbox", site: false, mail: false },
        system: { title: "システムに関するお知らせ", description: "", type: "checkbox", site: false, mail: false },
      } as NoticeInputs,
      notificationSetting: {} as NotificationSetting
    };
  },
  async beforeRouteEnter(to, from, next) {
    try {
      // 表示用情報取得
      const res = await getNotificationSetting();
      next(vm => {
        (vm.$data as Data).notificationSetting  = res;
        (vm.$data as Data).noticeInputs.assessment.site = res.isAssessmentNotif;
        (vm.$data as Data).noticeInputs.assessment.mail = res.isAssessmentMail,
        (vm.$data as Data).noticeInputs.assessmentComment.site = res.isAssessmentCommentNotif,
        (vm.$data as Data).noticeInputs.assessmentComment.mail = res.isAssessmentCommentMail,
        (vm.$data as Data).noticeInputs.projectComment.site = res.isProjectCommentNotif,
        (vm.$data as Data).noticeInputs.projectComment.mail = res.isProjectCommentMail,
        (vm.$data as Data).noticeInputs.service.site = res.isServiceNotif,
        (vm.$data as Data).noticeInputs.service.mail = res.isServiceMail,
        (vm.$data as Data).noticeInputs.system.site = res.isSystemNotif,
        (vm.$data as Data).noticeInputs.system.mail = res.isSystemMail
      });
    } catch (e) {
      // APIエラー
      next({ name: "Top" });
    }
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
    mode(): string {
      return this.$store.state.mode;
    },
  },
  methods: {
    async submit() {
      try {
        await updateNotificationSetting({
          isAssessmentNotif: this.noticeInputs.assessment.site,
          isAssessmentMail: this.noticeInputs.assessment.mail,
          isAssessmentCommentNotif: this.noticeInputs.assessmentComment.site,
          isAssessmentCommentMail: this.noticeInputs.assessmentComment.mail,
          isProjectCommentNotif: this.noticeInputs.projectComment.site,
          isProjectCommentMail: this.noticeInputs.projectComment.mail,
          isServiceNotif: this.noticeInputs.service.site,
          isServiceMail: this.noticeInputs.service.mail,
          isSystemNotif: this.noticeInputs.system.site,
          isSystemMail: this.noticeInputs.system.mail
        });
      } catch (error) {
        this.$emit('errorToast', '通知設定の更新に失敗しました');
        return;
      }
      this.$emit('toast', '通知設定を更新しました');
    },
  }
});
